$(function () {
    console.log("read");
    var path="";
    var devRef = document.referrer;
  
    $('.devRedirect').val(devRef);
  
    if(devRef.includes("embajadores") || devRef.includes("ambassadors")){
      var url = new URL(devRef);
      path = url.pathname;

       $('.devRedirect').val("/products/kit-de-inscripcion-embajadores-leonisa");
    }
    
    localStorage.setItem("redirect_url", path);
  });